import styled, { keyframes } from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

/**
 * Layout-only wrapper. Visual styling (background, foreground, padding,
 * border-radius) is owned by the {@code StatusPill} atom rendered inside.
 * This wrapper exists to:
 *   - co-locate the pill and the (drift-only) Refresh button on one row,
 *   - expose {@code data-status} / {@code data-tone} / {@code title} on a
 *     stable test target so the indicator's behaviour can be queried
 *     without coupling to the pill atom's internals.
 */
export const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level2};
`;

// Icon-only on phones so the process name keeps the room; still read by screen readers.
export const Label = styled.span`
  @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
`;

export const SpinnerIcon = styled.span`
  display: inline-flex;
  align-items: center;
  animation: ${spin} 1s linear infinite;
`;
